import React from 'react';
import { useCallback, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from '@google-recaptcha/react';
import HomePage2 from './components/pages/test';
import HomePage from './components/pages/HomePage';
import TestPage from './components/pages/HomePage2';
import InsertEmailSettings from './components/pages/SettingsForm';

const App = () => {

  const { executeV3 } = useGoogleReCaptcha();
  //console.log("execute recaptcha", executeV3);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeV3) {
      console.log("Execute recaptcha not available yet.");
      return;
    }
  
    setTimeout(async () => {
      try {
        const token = await executeV3("homepage");
        //console.log("ReCaptcha Token:", token);
        //http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/models/reCaptcha.php
        ///domainscan/models/reCaptcha.php
        const response = await fetch('/domainscan/models/reCaptcha.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ token: token }),
        });
  
        const data = await response.json();
        //console.log('Response from server:', data);
      } catch (error) {
        console.error("ReCaptcha Execution Error:", error);
      }
    }, 2000);

  }, [executeV3]);

  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/settings" element={<InsertEmailSettings />} />
        </Routes>
      </BrowserRouter>
    );
  };

export default App;